export enum FilterOperator {
  AND = 'AND',
  OR = 'OR'
}